import { render, staticRenderFns } from "./BugReportAutomationBtn.vue?vue&type=template&id=6b7d1025&scoped=true&"
import script from "./BugReportAutomationBtn.vue?vue&type=script&lang=ts&"
export * from "./BugReportAutomationBtn.vue?vue&type=script&lang=ts&"
import style0 from "./BugReportAutomationBtn.vue?vue&type=style&index=0&id=6b7d1025&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7d1025",
  null
  
)

export default component.exports